import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { useLanguageCurrency, formatPhoneNumber } from '../context/LanguageCurrencyContext';

const TermsOwner = () => {
  const { language } = useLanguageCurrency();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#1D2A3B', width: '100%' }}>
      <Navbar />

      {/* Hero Section */}
      <section 
        className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden"
        style={{ 
          background: 'linear-gradient(135deg, rgba(29, 42, 59, 1) 0%, rgba(29, 42, 59, 0.98) 30%, rgba(213, 181, 119, 0.08) 70%, rgba(29, 42, 59, 0.95) 100%)',
          width: '100%',
          minHeight: 'auto',
        }}
      >
        <div className="w-full max-w-7xl mx-auto relative z-10">
          <div className="text-center">
            <div className="inline-block mb-6">
              <div className="w-20 h-1 mx-auto mb-3 rounded-full animate-line-expand" style={{ 
                background: 'linear-gradient(90deg, transparent, #D5B577, transparent)',
                boxShadow: '0 0 10px rgba(213, 181, 119, 0.5)'
              }}></div>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight relative flex items-center justify-center flex-wrap gap-2 sm:gap-4" style={{ 
              textShadow: '0 0 30px rgba(213, 181, 119, 0.3), 0 4px 8px rgba(0, 0, 0, 0.3)'
            }}>
              <span className="relative inline-flex items-center justify-center gap-2 sm:gap-4">
                {/* Terms Icon - Document/File Icon */}
                <svg 
                  className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 animate-icon-float"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                  style={{
                    color: '#D5B577',
                    filter: 'drop-shadow(0 0 10px rgba(213, 181, 119, 0.5))'
                  }}
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
                  />
                </svg>
                {/* Animated Text */}
                <span className="terms-text">
                  {language === 'ar' ? (
                    <span
                      style={{
                        background: 'linear-gradient(135deg, #D5B577 0%, #f5d89a 50%, #D5B577 100%)',
                        backgroundSize: '200% 200%',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        animation: 'gradient-shift-once 3s ease-in-out forwards',
                      }}
                    >
                      {language === 'ar' ? 'الشروط والأحكام لمُلّاك العقارات' : 'Terms & Conditions for Property Owners'}
                    </span>
                  ) : (
                    (language === 'ar' ? 'الشروط والأحكام لمُلّاك العقارات' : 'Terms & Conditions for Property Owners').split('').map((char, index) => (
                      <span
                        key={index}
                        className="inline-block"
                        style={{
                          animationDelay: `${index * 0.08}s`,
                          background: 'linear-gradient(135deg, #D5B577 0%, #f5d89a 50%, #D5B577 100%)',
                          backgroundSize: '200% 200%',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text',
                          animation: 'gradient-shift-once 3s ease-in-out forwards',
                        }}
                      >
                        {char === ' ' ? '\u00A0' : char}
                      </span>
                    ))
                  )}
                </span>
                {/* Animated underline */}
                <div className="absolute -bottom-2 left-0 right-0 h-0.5 animate-underline-expand" style={{
                  background: 'linear-gradient(90deg, transparent, #D5B577, transparent)',
                  opacity: 0.8
                }}></div>
                {/* Glow effect */}
                <div className="absolute inset-0 animate-pulse-glow" style={{
                  background: 'radial-gradient(circle, rgba(213, 181, 119, 0.2) 0%, transparent 70%)',
                  filter: 'blur(20px)',
                  zIndex: -1
                }}></div>
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 max-w-2xl mx-auto leading-relaxed font-light animate-fade-in-up" style={{
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
              animationDelay: '0.8s',
              animationFillMode: 'both'
            }}>
              {language === 'ar' ? 'يرجى قراءة هذه الشروط بعناية قبل أن تصبح شريكًا' : 'Short Version for Property Owners'}
            </p>
            <div className="w-20 h-1 mx-auto mt-6 rounded-full animate-line-expand-delayed" style={{ 
              background: 'linear-gradient(90deg, transparent, #D5B577, transparent)',
              boxShadow: '0 0 10px rgba(213, 181, 119, 0.5)'
            }}></div>
            <div className="flex justify-center gap-4 mt-6">
              <button
                onClick={() => setLanguage('ar')}
                className={`px-4 py-2 rounded-lg transition-all duration-200 ${
                  language === 'ar' 
                    ? 'bg-[#D5B577] text-[#1D2A3B]' 
                    : 'bg-slate-700 text-gray-300 hover:bg-slate-600'
                }`}
              >
                العربية
              </button>
              <button
                onClick={() => setLanguage('en')}
                className={`px-4 py-2 rounded-lg transition-all duration-200 ${
                  language === 'en' 
                    ? 'bg-[#D5B577] text-[#1D2A3B]' 
                    : 'bg-slate-700 text-gray-300 hover:bg-slate-600'
                }`}
              >
                English
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Terms Content */}
      <section className="py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#1D2A3B', width: '100%' }}>
        <div className="w-full max-w-4xl mx-auto">
          <div className="bg-slate-800/50 rounded-2xl p-6 sm:p-8 md:p-10 shadow-xl border border-amber-500/20" dir={language === 'ar' ? 'rtl' : 'ltr'}>
            
            {/* Introduction */}
            <div className="mb-8">
              <p className="text-gray-300 leading-relaxed mb-4" style={{ textAlign: language === 'ar' ? 'right' : 'left', fontSize: '1.1rem' }}>
                {language === 'ar' 
                  ? 'تهدف هوستا غلوبال للتنمية العقارية إلى إدارة وتشغيل الوحدات العقارية نيابةً عن مُلّاكها ضمن إطار قانوني وتشغيلي واضح يضمن حقوق جميع الأطراف.'
                  : 'Hosta Global Real Estate Development provides professional property management and operation services under a clear legal and operational framework that protects all parties\' rights.'}
              </p>
            </div>

            {/* Relationship Nature */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#D5B577' }}>
                {language === 'ar' ? '1. طبيعة العلاقة' : '1. Relationship Nature'}
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 leading-relaxed" style={{ marginLeft: language === 'ar' ? '0' : '1rem', marginRight: language === 'ar' ? '1rem' : '0' }}>
                {language === 'ar' ? (
                  <>
                    <li>يوافق المالك على تفويض الشركة تفويضًا حصريًا لإدارة وتشغيل وتسويق العقار.</li>
                    <li>تتولى الشركة التأجير قصير وطويل الأجل، إدارة الضيوف، التسويق، والتحصيل المالي.</li>
                  </>
                ) : (
                  <>
                    <li>The Owner grants the Company exclusive authority to manage, operate, and market the property.</li>
                    <li>The Company handles short and long-term rentals, guest management, marketing, and revenue collection.</li>
                  </>
                )}
              </ul>
            </div>

            {/* Pricing & Operations */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#D5B577' }}>
                {language === 'ar' ? '2. التسعير والتشغيل' : '2. Pricing & Operations'}
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 leading-relaxed" style={{ marginLeft: language === 'ar' ? '0' : '1rem', marginRight: language === 'ar' ? '1rem' : '0' }}>
                {language === 'ar' ? (
                  <>
                    <li>تحدد الشركة أسعار الإقامة وسياسات التشغيل وفق متغيرات السوق.</li>
                    <li>يتم التشغيل لتحقيق أفضل نسب إشغال ممكنة مع الالتزام بالحد الأدنى للعوائد المتفق عليها.</li>
                  </>
                ) : (
                  <>
                    <li>Pricing and operating policies are determined based on market conditions.</li>
                    <li>Operations aim to achieve optimal occupancy while maintaining agreed minimum returns.</li>
                  </>
                )}
              </ul>
            </div>

            {/* Revenue & Expenses */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#D5B577' }}>
                {language === 'ar' ? '3. الإيرادات والمصاريف' : '3. Revenue & Expenses'}
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' ? 'تقوم الشركة بتحصيل جميع الإيرادات الناتجة عن التأجير.' : 'The Company collects all rental revenues.'}
              </p>
              <p className="text-gray-300 leading-relaxed mb-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' ? 'تتولى الشركة سداد:' : 'The Company covers:'}
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 leading-relaxed" style={{ marginLeft: language === 'ar' ? '0' : '1rem', marginRight: language === 'ar' ? '1rem' : '0' }}>
                {language === 'ar' ? (
                  <>
                    <li>المياه</li>
                    <li>الكهرباء</li>
                    <li>الإنترنت</li>
                  </>
                ) : (
                  <>
                    <li>Water</li>
                    <li>Electricity</li>
                    <li>Internet</li>
                  </>
                )}
              </ul>
              <p className="text-gray-300 leading-relaxed mt-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' 
                  ? 'يتم خصم المصاريف من العائد الشهري مع توضيحها في كشف دوري. في حال تجاوز المصاريف قيمة العائد، يلتزم المالك بسداد الفرق.'
                  : 'Expenses are deducted from monthly returns with clear reporting. If expenses exceed revenues, the Owner shall pay the difference.'}
              </p>
            </div>

            {/* Preparation Period */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#D5B577' }}>
                {language === 'ar' ? '4. فترة التجهيز' : '4. Preparation Period'}
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 leading-relaxed" style={{ marginLeft: language === 'ar' ? '0' : '1rem', marginRight: language === 'ar' ? '1rem' : '0' }}>
                {language === 'ar' ? (
                  <>
                    <li>فترة تجهيز لا تتجاوز شهرًا واحدًا من تاريخ استلام العقار جاهزًا للتشغيل.</li>
                    <li>لا يستحق المالك أي عوائد خلال هذه الفترة.</li>
                    <li>لا يجوز سحب العقار خلالها إلا بموافقة الشركة مع تعويضها عن التكاليف.</li>
                  </>
                ) : (
                  <>
                    <li>A preparation period of up to one month from handover of a ready-to-operate property.</li>
                    <li>No revenue is due during this period.</li>
                    <li>Property withdrawal requires company approval and cost compensation.</li>
                  </>
                )}
              </ul>
            </div>

            {/* Owner Usage */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#D5B577' }}>
                {language === 'ar' ? '5. استخدام المالك لعقاره' : '5. Owner Usage'}
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' ? 'يحق للمالك استخدام العقار لمدة لا تتجاوز شهرًا واحدًا سنويًا.' : 'The Owner may use the property up to one month per year.'}
              </p>
              <p className="text-gray-300 leading-relaxed mb-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' ? 'يتم تقسيم المدة بحد أقصى:' : 'Usage is limited to:'}
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 leading-relaxed" style={{ marginLeft: language === 'ar' ? '0' : '1rem', marginRight: language === 'ar' ? '1rem' : '0' }}>
                {language === 'ar' ? (
                  <>
                    <li>أسبوع واحد في المواسم أو الأعياد</li>
                    <li>ثلاثة أسابيع خلال باقي السنة</li>
                  </>
                ) : (
                  <>
                    <li>One week during peak seasons or holidays</li>
                    <li>Three weeks during the rest of the year</li>
                  </>
                )}
              </ul>
              <p className="text-gray-300 leading-relaxed mt-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' 
                  ? 'تستمر خصم المصاريف الدورية خلال فترة الاستخدام.'
                  : 'Fixed operating costs continue to apply during usage.'}
              </p>
            </div>

            {/* Owner Account */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#D5B577' }}>
                {language === 'ar' ? '6. حساب المالك' : '6. Owner Account'}
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' ? 'يتم تفعيل حساب إلكتروني خاص فور اعتماد العقار.' : 'A dedicated digital account is activated upon property approval.'}
              </p>
              <p className="text-gray-300 leading-relaxed mb-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' ? 'يتيح الحساب:' : 'The account allows:'}
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 leading-relaxed" style={{ marginLeft: language === 'ar' ? '0' : '1rem', marginRight: language === 'ar' ? '1rem' : '0' }}>
                {language === 'ar' ? (
                  <>
                    <li>متابعة الحجوزات</li>
                    <li>الاطلاع على الإيرادات</li>
                    <li>مراجعة المصاريف والخصومات</li>
                    <li>مقارنة نسب الإشغال</li>
                  </>
                ) : (
                  <>
                    <li>Booking tracking</li>
                    <li>Revenue monitoring</li>
                    <li>Expense review</li>
                    <li>Occupancy comparison</li>
                  </>
                )}
              </ul>
              <p className="text-gray-300 leading-relaxed mt-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' 
                  ? 'تختلف الصلاحيات حسب نوع العقار والخطة المتفق عليها. لا يحق سحب أي مبالغ إلا وفق جداول الصرف التعاقدية.'
                  : 'Access levels vary by property type and agreed plan. Withdrawals follow contractual payout schedules only.'}
              </p>
            </div>

            {/* Liability Limits */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#D5B577' }}>
                {language === 'ar' ? '7. حدود المسؤولية' : '7. Liability Limits'}
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' ? 'لا تتحمل الشركة مسؤولية عن:' : 'The Company is not liable for:'}
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 leading-relaxed" style={{ marginLeft: language === 'ar' ? '0' : '1rem', marginRight: language === 'ar' ? '1rem' : '0' }}>
                {language === 'ar' ? (
                  <>
                    <li>عيوب قانونية أو إنشائية سابقة</li>
                    <li>مخالفات متعلقة بملكية العقار</li>
                  </>
                ) : (
                  <>
                    <li>Pre-existing legal or structural defects</li>
                    <li>Ownership-related violations</li>
                  </>
                )}
              </ul>
              <p className="text-gray-300 leading-relaxed mt-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' 
                  ? 'سقف المسؤولية محدد تعاقديًا ومقيد.'
                  : 'Liability limits are contractually capped.'}
              </p>
            </div>

            {/* Contract Termination */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#D5B577' }}>
                {language === 'ar' ? '8. إنهاء التعاقد' : '8. Contract Termination'}
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 leading-relaxed" style={{ marginLeft: language === 'ar' ? '0' : '1rem', marginRight: language === 'ar' ? '1rem' : '0' }}>
                {language === 'ar' ? (
                  <>
                    <li>يجوز للمالك طلب إنهاء التعاقد بعد فترة السماح وفق الإجراءات المعتمدة.</li>
                    <li>لا يؤثر الإنهاء على الحجوزات القائمة أو المستحقات السابقة.</li>
                  </>
                ) : (
                  <>
                    <li>Termination may be requested after the grace period following agreed procedures.</li>
                    <li>Existing bookings and outstanding financial obligations remain valid.</li>
                  </>
                )}
              </ul>
            </div>

            {/* Disclaimer */}
            <div className="mb-8 bg-amber-500/10 border border-amber-500/30 rounded-lg p-6">
              <h3 className="text-xl font-semibold mb-4" style={{ color: '#D5B577' }}>
                {language === 'ar' ? 'تنويه' : 'Disclaimer'}
              </h3>
              <ul className="space-y-2 text-gray-300 leading-relaxed" style={{ marginLeft: language === 'ar' ? '0' : '1rem', marginRight: language === 'ar' ? '1rem' : '0' }}>
                {language === 'ar' ? (
                  <>
                    <li>📌 هذه نسخة تعريفية مختصرة.</li>
                    <li>📄 الاتفاقية القانونية الكاملة هي المرجع النهائي المنظم للعلاقة بين المالك والشركة.</li>
                  </>
                ) : (
                  <>
                    <li>📌 This is a summarized informational version.</li>
                    <li>📄 The full legal agreement is the final governing reference.</li>
                  </>
                )}
              </ul>
            </div>

            {/* General Provisions */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#D5B577' }}>
                {language === 'ar' ? 'ثالثًا: أحكام عامة' : '3. Final Provisions'}
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 leading-relaxed" style={{ marginLeft: language === 'ar' ? '0' : '1rem', marginRight: language === 'ar' ? '1rem' : '0' }}>
                {language === 'ar' ? (
                  <>
                    <li>تخضع الشروط لقوانين جمهورية مصر العربية.</li>
                    <li>الاختصاص لمحاكم القاهرة.</li>
                    <li>بطلان أي بند لا يؤثر على باقي البنود.</li>
                  </>
                ) : (
                  <>
                    <li>Governed by the laws of the Arab Republic of Egypt.</li>
                    <li>Cairo courts have jurisdiction.</li>
                    <li>Invalid clauses do not affect remaining clauses.</li>
                  </>
                )}
              </ul>
            </div>

            {/* Contact Information */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#D5B577' }}>
                {language === 'ar' ? 'معلومات الاتصال' : 'Contact Us'}
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                {language === 'ar' ? 'إذا كان لديك أي أسئلة حول هذه الشروط والأحكام، يرجى الاتصال بنا:' : 'If you have any questions about these Terms and Conditions, please contact us:'}
              </p>
              <div className="bg-slate-700/50 rounded-lg p-4 mt-4">
                <p className="text-gray-300 mb-2" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                  <strong style={{ color: '#D5B577' }}>{language === 'ar' ? 'البريد الإلكتروني:' : 'Email:'}</strong> partners@hostaglobal.com
                </p>
                <p className="text-gray-300 mb-2" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                  <strong style={{ color: '#D5B577' }}>{language === 'ar' ? 'الهاتف:' : 'Phone:'}</strong> {formatPhoneNumber('+20 100 000 0000', language)}
                </p>
                <p className="text-gray-300" style={{ textAlign: language === 'ar' ? 'right' : 'left' }}>
                  <strong style={{ color: '#D5B577' }}>{language === 'ar' ? 'العنوان:' : 'Address:'}</strong> {language === 'ar' ? 'القاهرة، مصر' : 'Cairo, Egypt'}
                </p>
              </div>
            </div>

            {/* Acknowledgment */}
            <div className="mt-10 pt-6 border-t border-gray-700">
              <p className="text-gray-400 text-sm text-center" style={{ textAlign: language === 'ar' ? 'right' : 'center' }}>
                {language === 'ar' 
                  ? 'بإنشاء حساب مالك عقار وإدراج العقارات على هوستا جلوبال، فإنك تقر بأنك قد قرأت وفهمت ووافقت على الالتزام بهذه الشروط والأحكام.'
                  : 'By creating a Property Owner account and listing properties on HOSTA GLOBAL, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.'}
              </p>
              <div className="text-center mt-4">
                <Link 
                  to="/register-owner" 
                  className="inline-block px-6 py-2 rounded-lg transition-all duration-200"
                  style={{ backgroundColor: '#D5B577', color: '#1D2A3B' }}
                >
                  {language === 'ar' ? 'العودة إلى تسجيل الشريك' : 'Return to Partner Registration'}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
      
      {/* CSS Animations */}
      <style>{`
        @keyframes gradient-shift-once {
          0% { 
            background-position: 0% 50%;
            transform: translateY(0);
            opacity: 0;
          }
          50% { 
            background-position: 100% 50%;
            transform: translateY(-3px);
            opacity: 1;
          }
          100% { 
            background-position: 0% 50%;
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes underline-expand {
          0% { 
            width: 0;
            opacity: 0;
          }
          50% {
            opacity: 0.8;
          }
          100% { 
            width: 100%;
            opacity: 0.8;
          }
        }
        
        @keyframes pulse-glow {
          0%, 100% { 
            opacity: 0.3;
            transform: scale(1);
          }
          50% { 
            opacity: 0.6;
            transform: scale(1.1);
          }
        }
        
        @keyframes line-expand {
          0% { 
            width: 0;
            opacity: 0;
          }
          100% { 
            width: 80px;
            opacity: 1;
          }
        }
        
        @keyframes line-expand-delayed {
          0% { 
            width: 0;
            opacity: 0;
          }
          50% {
            opacity: 0;
          }
          100% { 
            width: 80px;
            opacity: 1;
          }
        }
        
        @keyframes fade-in-up {
          0% { 
            opacity: 0;
            transform: translateY(20px);
          }
          100% { 
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes icon-float {
          0%, 100% { 
            transform: translateY(0) rotate(0deg);
          }
          50% { 
            transform: translateY(-8px) rotate(5deg);
          }
        }
        
        .terms-text span {
          animation: letter-float-once 2s ease-out forwards;
        }
        
        @keyframes letter-float-once {
          0% { 
            transform: translateY(20px) rotate(0deg);
            opacity: 0;
          }
          100% { 
            transform: translateY(0) rotate(0deg);
            opacity: 1;
          }
        }
        
        .animate-line-expand {
          animation: line-expand 1.5s ease-out forwards;
        }
        
        .animate-underline-expand {
          animation: underline-expand 1.2s ease-out 0.5s forwards;
        }
        
        .animate-pulse-glow {
          animation: pulse-glow 3s ease-in-out infinite;
        }
        
        .animate-line-expand-delayed {
          animation: line-expand-delayed 1.5s ease-out 1s forwards;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out forwards;
          opacity: 0;
        }
        
        .animate-icon-float {
          animation: icon-float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default TermsOwner;
